export const testimonials = [
  {
    id: 1,
    name: "李明远",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%2C%20warm%20lighting%2C%20simple%20cream%20background%2C%20friendly%20expression%2C%20headshot%20photography&width=80&height=80&seq=avatar-1&orientation=squarish",
    role: "资深媒体人",
    content: "爱情岛独家的内容质量确实令人惊喜。在这个信息爆炸的时代，能找到这样一个用心筛选、精心呈现内容的平台实在难得。每一篇文章都能感受到编辑的用心。",
    rating: 5,
  },
  {
    id: 2,
    name: "王思涵",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20warm%20studio%20lighting%2C%20simple%20cream%20background%2C%20confident%20smile%2C%20headshot%20photography&width=80&height=80&seq=avatar-2&orientation=squarish",
    role: "内容创作者",
    content: "作为一个内容创作者，我在这里找到了很多灵感。平台的分类清晰，推荐精准，高清画质更是让观看体验上了一层楼。已经成为我每天必刷的平台。",
    rating: 5,
  },
  {
    id: 3,
    name: "张伟杰",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%2C%20warm%20lighting%2C%20simple%20cream%20background%2C%20calm%20expression%2C%20headshot%20photography&width=80&height=80&seq=avatar-3&orientation=squarish",
    role: "企业高管",
    content: "工作之余最大的放松就是来爱情岛独家看看。深度解读栏目让我在碎片化时间也能获得有营养的内容。推荐给了很多同事，大家反馈都很好。",
    rating: 5,
  },
  {
    id: 4,
    name: "陈思雨",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20warm%20studio%20lighting%2C%20simple%20cream%20background%2C%20gentle%20smile%2C%20headshot%20photography&width=80&height=80&seq=avatar-4&orientation=squarish",
    role: "设计师",
    content: "视觉体验太棒了！平台的UI设计审美在线，配合高清内容简直是双重享受。经典的回顾栏目让我发现了很多之前错过的好作品。",
    rating: 5,
  },
  {
    id: 5,
    name: "刘浩然",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%2C%20warm%20lighting%2C%20simple%20cream%20background%2C%20friendly%20expression%2C%20headshot%20photography&width=80&height=80&seq=avatar-5&orientation=squarish",
    role: "大学讲师",
    content: "深度解读栏目的文章质量非常高，我经常推荐学生来这里阅读。内容有深度有温度，是难得的优质内容平台。希望能一直保持这样的水准。",
    rating: 5,
  },
];